import { Icon, Pill } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

interface FieldTypePillProps {
  type: Nullable<"employee" | "position" | "group">;
  pillProps?: Partial<React.ComponentProps<typeof Pill>>;
}

export default function FieldTypePill({ type, pillProps }: FieldTypePillProps) {
  if (!type) {
    return null;
  }

  const label =
    type === "employee"
      ? appstr("Employee")
      : type === "position"
        ? appstr("Position")
        : appstr("group");
  const icon = type === "employee" ? "image-user" : type === "position" ? "cubes" : "grouping";

  return (
    <Pill
      label={label.toLowerCase()}
      size={"compact"}
      leftContent={<Icon name={icon} size="small" color="inherit" />}
      {...pillProps}
    />
  );
}
